export default __webpack_public_path__ + "static/media/Instagram.0ae817cd.svg";